import React from "react";
import initialData from "./initial-data";
import Column from "./column";
import { styled } from "styled-components";
import { DragDropContext } from 'react-beautiful-dnd';

const Container = styled.div`
	max-width: 1000px;
	margin: 0 auto;
	display: flex;
	flex-wrap: wrap;
`;

const ResetSteps = styled.button`
display: block;
background-color: #0073ff;;
color: #fff;
padding: 5px 15px;
border-radius: 10px;
`;

const ResetHipster = styled.button`
display: block;;
background-color: #0073ff;;
color: #fff;
padding: 5px 15px;
border-radius: 10px;
`;

export default class Steps extends React.Component {
	state = initialData;

	onDragStart = (result) => {
		console.log('drag start', result.draggableId);
		// document.body.style.color = 'orange';
	};

	onDragUpdate = result => {
		// console.log('update result', result);
		// const destIndex = result.destination.index + 1;
		// console.log('dest', destIndex);
		// const destStep = result.destination.droppableId + '-' + destIndex;
		// console.warn('destStep', destStep);
		// let step = document.getElementById(result.draggableId);
		// if ( result.draggableId === destStep ) {
		// 	step.style.background = 'green';
		// 	step.style.color = '#fff';
		// } else {
		// 	step.style.background= '';
		// 	step.style.color = '';
		// }
	}

	onDragEnd = result => {
		console.log('end result', result );
		document.body.style.color = 'inherit';
		const { destination, source, draggableId } = result;
		if ( !destination) {
			return;
		}
		if ( destination.droppableId !== source.droppableId || destination.index === source.index ) {
			return;
		}
		const column = this.state.columns[source.droppableId];
		const newStepIds = Array.from(column.stepIds);
		newStepIds.splice(source.index, 1);
		newStepIds.splice(destination.index, 0, draggableId );

		const NewColumn = {
			...column,
			stepIds: newStepIds
		};

		const newState = {
			...this.state,
			columns: {
				...this.state.columns,
				[NewColumn.id]: NewColumn
			}
		};

		this.setState(newState);
	}

	sortAllSteps = e => {
		var collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});
		const stepColumn = this.state.columns['step'];
		let steps = Array.from(stepColumn.stepIds);
		let sortedSteps = steps.sort(collator.compare);
		const newColumn = {
			...stepColumn,
			stepIds: sortedSteps
		};

		const newState = {
			...this.state,
			columns: {
				...this.state.columns,
				'step': newColumn
			}
		};

		this.setState(newState);
	}

	sortAllHipster = e => {
		var collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});
		const stepColumn = this.state.columns['hipster'];
		let steps = Array.from(stepColumn.stepIds);
		let sortedSteps = steps.sort(collator.compare);
		const newColumn = {
			...stepColumn,
			stepIds: sortedSteps
		};

		const newState = {
			...this.state,
			columns: {
				...this.state.columns,
				'hipster': newColumn
			}
		};

		this.setState(newState);
	}

	render() {
		return (
			<>
				{/* <ResetSteps onClick={this.sortAllSteps}>Admit Defeat</ResetSteps> */}
				<DragDropContext onDragStart={this.onDragStart} onDragUpdate={this.onDragUpdate} onDragEnd={this.onDragEnd}	>
					<Container>
						{
							this.state.columnOrder.map(columnId => {
								const column = this.state.columns[columnId];
								const steps = column.stepIds.map((stepId) => this.state.steps[stepId]);
								return <Column key={column.id} column={column} steps={steps} />;
							})
						}
					</Container>
				</DragDropContext>

				<ResetHipster onClick={this.sortAllHipster}>Surrender</ResetHipster>
			</>
		)
	}
}